import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuOptions } from '../types/ui';
import { AppStore } from '../types/store/AppStore';
import { PrivateSettings, PublicSettings } from '../types/interfaces/app';

const initialState: AppStore= JSON.parse(sessionStorage.getItem("app") || "{}");

const app = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setPublicSettings: (state, action: PayloadAction<PublicSettings>) => {
      state.publicSettings = action.payload;
      sessionStorage.setItem('app', JSON.stringify(state));
    },
    setPrivateSettings: (state, action: PayloadAction<PrivateSettings>) => {
      state.privateSettings = action.payload;
      sessionStorage.setItem('app', JSON.stringify(state));
    },
    clearSettings: (state) => {
      state.privateSettings = undefined;
      state.publicSettings = undefined;
      sessionStorage.setItem('app', JSON.stringify({}));
    },
  },
});

export const { setPublicSettings, setPrivateSettings, clearSettings } = app.actions;

export default app.reducer;
